module.exports = __webpack_public_path__ + "img/cn-stu.9122c1b8.png";